// removed by extract-text-webpack-plugin
module.exports = {"news-container":"src-components-News-___news__news-container___2dGX0","content-block":"src-components-News-___news__content-block___P3cnp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/News/news.css
// module id = 1101
// module chunks = 0